import React from 'react';
import {observer} from 'mobx-react';
import {FooterModuleLinks} from "../footer-module.links";
import classNames from "classnames";
import styles from "../../styles/footer.module.scss";

export const FooterModuleMobileLinks = observer(({controller, onItemClick}) => {
  const {state: {allLinks}} = controller;

  const linkProps = {
    controller,
    links: allLinks,
    onItemClick: (link) => onItemClick && onItemClick(link)
  }

  return (
    <div className={classNames(styles.links)}>
      <FooterModuleLinks {...linkProps}/>
    </div>
  );
});
